import { render, staticRenderFns } from "./purchaseCompletedLowPrice.vue?vue&type=template&id=0dd8210a&scoped=true"
import script from "./purchaseCompletedLowPrice.vue?vue&type=script&lang=js"
export * from "./purchaseCompletedLowPrice.vue?vue&type=script&lang=js"
import style0 from "./purchaseCompletedLowPrice.vue?vue&type=style&index=0&id=0dd8210a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd8210a",
  null
  
)

export default component.exports